import React, { useEffect, useState } from 'react';

import pckg from '../../../../package.json';
import { useIonModal } from '@ionic/react';

const DebugModal: React.FC<{ onOk: () => void }> = (props) => {
  return (
    <p
      style={{
        textAlign: 'center',
        fontSize: '28px',
        lineHeight: '34px',
        marginTop: '25px',
        color: '#5B5B5B',
      }}
    >
      v{pckg.version} ({pckg['code-version']})
      <br />
      {import.meta.env.VITE_APP_ENV === 'main' ? 'Production Build' : 'Develop Build'}
      <br />
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a onClick={props.onOk}>OK</a>
    </p>
  );
};

const CLICKS_MAX = 10;

const DebugClickWrapper: React.FC = (props) => {
  const [clickCount, setClickCount] = useState<number>(0);
  const [show, dismiss] = useIonModal(DebugModal, {
    onOk: () => {
      dismiss();
    },
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      setClickCount((prevState) => (prevState > 0 ? prevState - 1 : 0));
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const onClick = () => {
    setClickCount((prev) => prev + 1);
    if (clickCount >= CLICKS_MAX) {
      show();
      setClickCount(0);
      setTimeout(() => {
        dismiss();
      }, 20000);
    }
  };
  return <section onClick={onClick}>{props.children}</section>;
};

export default DebugClickWrapper;
